import { API_BASE_URL } from './base-url';
import { createAuthClient } from './auth-http-client';

const authBaseUrl = `${API_BASE_URL}/v1/auth`;
const shouldLogAuthRequests = import.meta.env.DEV;

const loggingFetch: typeof fetch = async (input, init) => {
  const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url;
  const method = init?.method ?? 'GET';
  // Debug only: log the auth URL being called and the current origin to spot CORS/base URL issues.
  console.debug('[auth-client] request', { url, method });
  return fetch(input, init);
};

export const authClient = createAuthClient({
  baseUrl: authBaseUrl,
  fetchImpl: shouldLogAuthRequests ? loggingFetch : undefined,
});
